import React, { useState } from 'react';
import { CreditCardIcon, UsersIcon, HomeIcon, SlidersHorizontalIcon, CalendarIcon, PencilIcon, MailIcon, BadgeCheckIcon, Trash2Icon, DownloadIcon, ChevronLeftIcon, ChevronRightIcon, ChevronsLeftIcon, ChevronsRightIcon, XIcon } from 'lucide-react';
// --- MOCK DATA ---
type ApprovalStatus = 'approved' | 'pending' | 'none' | 'unconfirmed' | 'no-card' | 'not-generated';
interface UserRecord {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  cardStatus: ApprovalStatus;
  cardNumber?: string;
  familyStatus: ApprovalStatus;
  familyCount?: number;
  propertyStatus: ApprovalStatus;
  propertyCount?: number;
  emailConfirmed: boolean;
}
const MOCK_DATA: UserRecord[] = [{
  id: '1',
  firstName: 'Hugo',
  lastName: 'Janelle',
  email: 'hugo.janelle@gmail.com',
  cardStatus: 'approved',
  cardNumber: '0040340859',
  familyStatus: 'approved',
  familyCount: 2,
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '2',
  firstName: 'Hugo',
  lastName: 'Morrissette',
  email: 'hugomorrissette3@gmail.com',
  cardStatus: 'no-card',
  familyStatus: 'none',
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '3',
  firstName: 'Hugo',
  lastName: 'Delgado',
  email: 'hugofernandod@gmail.com',
  cardStatus: 'approved',
  cardNumber: '0040341885',
  familyStatus: 'none',
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '4',
  firstName: 'Hugo',
  lastName: 'Delgado',
  email: 'minihugojuan@gmail.com',
  cardStatus: 'no-card',
  familyStatus: 'none',
  propertyStatus: 'none',
  emailConfirmed: false
}, {
  id: '5',
  firstName: 'Hugo',
  lastName: 'Delgado',
  email: 'monihugojuan@gmail.com',
  cardStatus: 'not-generated',
  familyStatus: 'approved',
  familyCount: 2,
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '6',
  firstName: 'yovanna',
  lastName: 'chavez',
  email: 'giocha2403@gmail.com',
  cardStatus: 'pending',
  familyStatus: 'approved',
  familyCount: 1,
  propertyStatus: 'none',
  emailConfirmed: false
}, {
  id: '7',
  firstName: 'Julia',
  lastName: 'Nayar',
  email: 'julialnayar@gmail.com',
  cardStatus: 'pending',
  familyStatus: 'none',
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '8',
  firstName: 'Amaury',
  lastName: 'Marqué',
  email: 'amaury.marque@gmail.com',
  cardStatus: 'pending',
  familyStatus: 'none',
  propertyStatus: 'pending',
  emailConfirmed: true
}, {
  id: '9',
  firstName: 'Lilyanna',
  lastName: 'Duff',
  email: 'N/D',
  cardStatus: 'pending',
  familyStatus: 'pending',
  propertyStatus: 'none',
  emailConfirmed: false
}, {
  id: '10',
  firstName: 'Marianne Rose',
  lastName: 'De Leon',
  email: 'marosedel@gmail.com',
  cardStatus: 'pending',
  familyStatus: 'pending',
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '11',
  firstName: 'Peter',
  lastName: 'Lefebvre',
  email: 'peterlefebvre2002@yahoo.ca',
  cardStatus: 'approved',
  cardNumber: '0040340839',
  familyStatus: 'none',
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '12',
  firstName: 'Jimmy',
  lastName: 'Cineas',
  email: 'jammeeskillz@live.fr',
  cardStatus: 'approved',
  cardNumber: '0040340827',
  familyStatus: 'none',
  propertyStatus: 'none',
  emailConfirmed: false
}, {
  id: '13',
  firstName: 'koorosh',
  lastName: 'Nikgotar',
  email: 'kooroshnikgoftar1380@gmail.com',
  cardStatus: 'not-generated',
  familyStatus: 'none',
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '14',
  firstName: 'Lucia',
  lastName: 'Cassagnet',
  email: 'lucia.cassagnet@gmail.com',
  cardStatus: 'approved',
  cardNumber: '0040343922',
  familyStatus: 'approved',
  familyCount: 1,
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '15',
  firstName: 'Cynthia',
  lastName: 'DEGNI',
  email: 'cybelle225@gmail.com',
  cardStatus: 'approved',
  cardNumber: '0040341208',
  familyStatus: 'approved',
  familyCount: 4,
  propertyStatus: 'none',
  emailConfirmed: true
}, {
  id: '16',
  firstName: 'Florence Michelle',
  lastName: 'Niéba',
  email: 'odetteleontin15@gmail.com',
  cardStatus: 'pending',
  familyStatus: 'none',
  propertyStatus: 'approved',
  propertyCount: 1,
  emailConfirmed: true
}];
type QuickFilter = 'none' | 'cartes' | 'liens' | 'proprietes';
export function BcitiIdSearch() {
  const [quickFilter, setQuickFilter] = useState<QuickFilter>('none');
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  // Filter logic
  const filteredData = MOCK_DATA.filter(user => {
    if (quickFilter === 'cartes') return user.cardStatus === 'pending';
    if (quickFilter === 'liens') return user.familyStatus === 'pending';
    if (quickFilter === 'proprietes') return user.propertyStatus === 'pending';
    return true;
  });
  // Render helpers
  const renderCardStatus = (user: UserRecord) => {
    if (user.cardStatus === 'pending') return <span className="px-2.5 py-0.5 bg-amber-100 text-amber-700 rounded-full text-xs font-bold" data-id="element-932" data-mp="2vil1r8sd4n7q">
          Approbation requise
        </span>;
    if (user.cardStatus === 'no-card') return <span className="text-slate-400 italic text-sm" data-id="element-933" data-mp="2y42lyfrlzdwa">Pas de carte</span>;
    if (user.cardStatus === 'not-generated') return <span className="text-slate-400 italic text-sm flex items-center gap-1" data-id="element-934" data-mp="3358b63m28j12">
          <CreditCardIcon className="w-3.5 h-3.5" data-id="element-935" data-mp="2p5qktjt48xpl" /> Numéro non généré
        </span>;
    return <span className="text-slate-700 text-sm flex items-center gap-1" data-id="element-936" data-mp="2t6iuge5wh4me">
        <CreditCardIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-937" data-mp="3gutqn40nig4c" />{' '}
        {user.cardNumber}
      </span>;
  };
  const renderFamilyStatus = (user: UserRecord) => {
    if (user.familyStatus === 'pending') return <span className="px-2.5 py-0.5 bg-amber-100 text-amber-700 rounded-full text-xs font-bold cursor-pointer hover:bg-amber-200 transition-colors" data-id="element-938" data-mp="383te4asp5gt7">
          Voir la demande
        </span>;
    if (user.familyStatus === 'approved') return <span className="px-2.5 py-0.5 bg-emerald-100 text-emerald-700 rounded-full text-xs font-bold" data-id="element-939" data-mp="3nijaty0gkg1">
          {user.familyCount} lien(s)
        </span>;
    return <span className="text-slate-400 italic text-sm" data-id="element-940" data-mp="ibsc6i2ucaip">Aucun lien</span>;
  };
  const renderPropertyStatus = (user: UserRecord) => {
    if (user.propertyStatus === 'pending') return <span className="px-2.5 py-0.5 bg-amber-100 text-amber-700 rounded-full text-xs font-bold cursor-pointer hover:bg-amber-200 transition-colors" data-id="element-941" data-mp="9au8k0wbe50n">
          Voir la demande
        </span>;
    if (user.propertyStatus === 'approved') return <span className="text-slate-700 text-sm" data-id="element-942" data-mp="3vj2dthiw26mj">
          {user.propertyCount} résidence
        </span>;
    return <span className="text-slate-400 italic text-sm" data-id="element-943" data-mp="3qqisfydym776">Aucune</span>;
  };
  return <div className="flex flex-col gap-4 animate-in fade-in duration-300 font-body" data-id="element-944" data-mp="3moxjup8gkf2s">
      {/* TOOLBAR */}
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4" data-id="element-945" data-mp="3hroyygvxdwxu">
        <div className="flex flex-wrap items-center gap-2" data-id="element-946" data-mp="3crssmazr9tf4">
          <button onClick={() => setQuickFilter(quickFilter === 'cartes' ? 'none' : 'cartes')} className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-semibold transition-colors border ${quickFilter === 'cartes' ? 'bg-[#0F172A] text-white border-[#0F172A]' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'}`} data-id="element-947" data-mp="3ctdmrzi5racg">
            <CreditCardIcon className="w-4 h-4" data-id="element-948" data-mp="37mfmvgh458q5" />
            Cartes à approuver
            <span className={`px-1.5 py-0.5 rounded-full text-xs ${quickFilter === 'cartes' ? 'bg-white/20 text-white' : 'bg-[#0F172A] text-white'}`} data-id="element-949" data-mp="3clienz831ig6">
              18
            </span>
          </button>

          <button onClick={() => setQuickFilter(quickFilter === 'liens' ? 'none' : 'liens')} className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-semibold transition-colors border ${quickFilter === 'liens' ? 'bg-[#0F172A] text-white border-[#0F172A]' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'}`} data-id="element-950" data-mp="2jwl8guh5bc3s">
            <UsersIcon className="w-4 h-4" data-id="element-951" data-mp="1w70pibkzseui" />
            Liens familiaux à approuver
            <span className={`px-1.5 py-0.5 rounded-full text-xs ${quickFilter === 'liens' ? 'bg-white/20 text-white' : 'bg-[#0F172A] text-white'}`} data-id="element-952" data-mp="215lgrli9no6t">
              9
            </span>
          </button>

          <button onClick={() => setQuickFilter(quickFilter === 'proprietes' ? 'none' : 'proprietes')} className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-semibold transition-colors border ${quickFilter === 'proprietes' ? 'bg-[#0F172A] text-white border-[#0F172A]' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'}`} data-id="element-953" data-mp="3bctc7whguuu2">
            <HomeIcon className="w-4 h-4" data-id="element-954" data-mp="3uacdgdxon95x" />
            Propriétés à approuver
            <span className={`px-1.5 py-0.5 rounded-full text-xs ${quickFilter === 'proprietes' ? 'bg-white/20 text-white' : 'bg-[#0F172A] text-white'}`} data-id="element-955" data-mp="3u89ps0k05s4d">
              5
            </span>
          </button>

          <button onClick={() => setShowAdvancedFilters(true)} className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium bg-white text-slate-600 border border-slate-200 hover:bg-slate-50 transition-colors" data-id="element-956" data-mp="6zmg4xhh8206">
            <SlidersHorizontalIcon className="w-4 h-4" data-id="element-957" data-mp="10gq074axxwnc" />
            Plus de filtres
          </button>

          {quickFilter !== 'none' && <button onClick={() => setQuickFilter('none')} className="px-3 py-2 text-sm font-medium text-slate-500 hover:text-slate-800 transition-colors" data-id="element-958" data-mp="14hjovzw7jfha">
              Réinitialiser
            </button>}
        </div>

        <button className="bg-[#4F46E5] hover:bg-[#4338CA] text-white px-5 py-2 rounded-lg text-sm font-bold transition-colors shadow-sm whitespace-nowrap" data-id="element-959" data-mp="vgbqlhtoyen7">
          Créer un compte d'utilisateur
        </button>
      </div>

      {/* SEARCH INPUTS */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-3" data-id="element-960" data-mp="7t3vfspz8lyw">
        <input type="text" placeholder="Prénom" className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-961" data-mp="cronv5yzm1cs" />
        <input type="text" placeholder="Nom de famille" className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-962" data-mp="2t7rtul6ywjv" />
        <div className="relative" data-id="element-963" data-mp="3ey2u3kyzp09z">
          <input type="text" placeholder="Date de naissance" className="w-full pl-3 pr-9 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-964" data-mp="3ez46bsrqrsta" />
          <CalendarIcon className="absolute right-3 top-2.5 w-4 h-4 text-slate-400 pointer-events-none" data-id="element-965" data-mp="351g7orr0m15u" />
        </div>
        <input type="text" placeholder="Courriel" className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-966" data-mp="1imx8ntj9sfw" />
        <input type="text" placeholder="Téléphone" className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-967" data-mp="3nxpkzcu3enos" />
        <input type="text" placeholder="Numéro de carte" className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-968" data-mp="kafskow2rpqs" />
      </div>

      {/* TABLE */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden mt-2" data-id="element-969" data-mp="1zyvtzjlizaw1">
        <div className="overflow-x-auto" data-id="element-970" data-mp="2erfibe40ndtf">
          <table className="w-full text-left text-sm whitespace-nowrap" data-id="element-971" data-mp="29q9rxmxtw2n2">
            <thead className="bg-[#0F172A] text-white" data-id="element-972" data-mp="1m0p3ioiwod6e">
              <tr data-id="element-973" data-mp="1m17b2hb0qdtm">
                <th className="px-4 py-3.5 font-semibold" data-id="element-974" data-mp="1m2s4u4pidsqf">Nom</th>
                <th className="px-4 py-3.5 font-semibold" data-id="element-975" data-mp="1h3f72ox3n192">Courriel</th>
                <th className="px-4 py-3.5 font-semibold" data-id="element-976" data-mp="1v1vob9sl8a5g">
                  Numéro de la carte
                </th>
                <th className="px-4 py-3.5 font-semibold" data-id="element-977" data-mp="1qz8skxssq52z">Liens familiaux</th>
                <th className="px-4 py-3.5 font-semibold" data-id="element-978" data-mp="36g95jvsu5rci">Propriétés</th>
                <th className="px-4 py-3.5 font-semibold" data-id="element-979" data-mp="32f78nlme5rdp">Courriel confirmé</th>
                <th className="px-4 py-3.5 font-semibold text-right" data-id="element-980" data-mp="32h9tlr8osubk"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-981" data-mp="1z6nltcgr63gj">
              {filteredData.map(user => <tr key={user.id} className="hover:bg-slate-50/50 transition-colors group" data-id="element-982" data-mp="245h3zi6ziin1">
                  <td className="px-4 py-3 text-slate-700" data-id="element-983" data-mp="2938rm00ljilf">
                    {user.firstName} {user.lastName}
                  </td>
                  <td className="px-4 py-3 text-slate-600" data-id="element-984" data-mp="1ge1vf7om753c">{user.email}</td>
                  <td className="px-4 py-3" data-id="element-985" data-mp="1gbywfy5hi1mh">{renderCardStatus(user)}</td>
                  <td className="px-4 py-3" data-id="element-986" data-mp="1ldegpnzu843t">{renderFamilyStatus(user)}</td>
                  <td className="px-4 py-3" data-id="element-987" data-mp="1pdf80981c9sa">{renderPropertyStatus(user)}</td>
                  <td className="px-4 py-3" data-id="element-988" data-mp="1u4ydw5otu5wo">
                    {user.emailConfirmed ? <span className="px-2.5 py-0.5 bg-emerald-100 text-emerald-700 rounded-full text-xs font-bold" data-id="element-989" data-mp="1u7azcstsmyeh">
                        Confirmé
                      </span> : <span className="px-2.5 py-0.5 bg-amber-100 text-amber-700 rounded-full text-xs font-bold" data-id="element-990" data-mp="11nue4vacfs48">
                        Non confirmé
                      </span>}
                  </td>
                  <td className="px-4 py-3" data-id="element-991" data-mp="p7l79fj1zyzo">
                    <div className="flex items-center justify-end gap-3 text-slate-400 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-992" data-mp="p4gsjo7ypkur">
                      <button className="hover:text-[#4F46E5] transition-colors" title="Modifier" data-id="element-993" data-mp="g4k1xh20ibx2">
                        <PencilIcon className="w-4 h-4" data-id="element-994" data-mp="b7k5zyyvmpjo" />
                      </button>
                      <button className="hover:text-[#4F46E5] transition-colors" title="Envoyer un courriel" data-id="element-995" data-mp="6fjztos7r0en">
                        <MailIcon className="w-4 h-4" data-id="element-996" data-mp="1hquexyqiaff" />
                      </button>
                      <button className="hover:text-[#4F46E5] transition-colors" title="Carte" data-id="element-997" data-mp="3tlaya1tvs5cg">
                        <BadgeCheckIcon className="w-4 h-4" data-id="element-998" data-mp="3olyfpta1lkfo" />
                      </button>
                      <button className="hover:text-red-500 transition-colors" title="Supprimer" data-id="element-999" data-mp="3jlshfu99ozom">
                        <Trash2Icon className="w-4 h-4" data-id="element-1000" data-mp="1ninr6hxw8pg6" />
                      </button>
                    </div>
                  </td>
                </tr>)}
              {filteredData.length === 0 && <tr data-id="element-1001" data-mp="1dte1f8qiviv8">
                  <td colSpan={7} className="px-4 py-8 text-center text-slate-500" data-id="element-1002" data-mp="1du5uocwnd4ic">
                    Aucun résultat trouvé.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>

        {/* FOOTER / PAGINATION */}
        <div className="px-4 py-3 border-t border-slate-100 flex flex-col sm:flex-row items-center justify-between gap-4 bg-slate-50/50" data-id="element-1003" data-mp="14usktj4m2dx3">
          <button className="flex items-center gap-2 text-xs font-bold text-[#0F172A] hover:text-[#4F46E5] transition-colors uppercase tracking-wider" data-id="element-1004" data-mp="uv1m1590pcr7">
            <DownloadIcon className="w-4 h-4" data-id="element-1005" data-mp="zvpcnptc3rkw" />
            Exporter les résultats
          </button>

          <div className="flex items-center gap-6 text-xs text-slate-500" data-id="element-1006" data-mp="2p6gdbqhofk92">
            <div className="flex items-center gap-2" data-id="element-1007" data-mp="2u743k9y2zx28">
              <span data-id="element-1008" data-mp="ik0vtt75qmp7">Éléments par page</span>
              <select className="bg-transparent font-bold text-slate-700 focus:outline-none cursor-pointer" data-id="element-1009" data-mp="ikshab71j41r">
                <option data-id="element-1010" data-mp="dn0rpntvbu0q">10</option>
                <option data-id="element-1011" data-mp="sa3qryxuaaq6">20</option>
                <option data-id="element-1012" data-mp="sb5aersx85ji">50</option>
              </select>
            </div>

            <div className="font-medium" data-id="element-1013" data-mp="niu0qx8dp5dr">1 - {filteredData.length} / 293</div>

            <div className="flex items-center gap-1" data-id="element-1014" data-mp="11as2gmzrfyzw">
              <button className="p-1 text-slate-400 hover:text-slate-700 disabled:opacity-50" data-id="element-1015" data-mp="119gxijukwl77">
                <ChevronsLeftIcon className="w-4 h-4" data-id="element-1016" data-mp="wavzmr2sudlx" />
              </button>
              <button className="p-1 text-slate-400 hover:text-slate-700 disabled:opacity-50" data-id="element-1017" data-mp="1b97uqtaixeaz">
                <ChevronLeftIcon className="w-4 h-4" data-id="element-1018" data-mp="169lhwkyly02p" />
              </button>
              <button className="p-1 text-slate-400 hover:text-slate-700 disabled:opacity-50" data-id="element-1019" data-mp="3d0b3te4rmktf">
                <ChevronRightIcon className="w-4 h-4" data-id="element-1020" data-mp="38182a3nzuwq7" />
              </button>
              <button className="p-1 text-slate-400 hover:text-slate-700 disabled:opacity-50" data-id="element-1021" data-mp="383b21fey8484">
                <ChevronsRightIcon className="w-4 h-4" data-id="element-1022" data-mp="1m2fd7f7wxrv" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ADVANCED FILTERS MODAL */}
      {showAdvancedFilters && <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-in fade-in duration-200" data-id="element-1023" data-mp="ajcsyzficyzy">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg overflow-hidden flex flex-col animate-in zoom-in-95 duration-200" data-id="element-1024" data-mp="kjdf0t4rht7u">
            <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between" data-id="element-1025" data-mp="oivyrlkujy93">
              <h3 className="text-lg font-bold text-[#0F172A] font-heading" data-id="element-1026" data-mp="tbozlyd72mfw">
                Filtres avancés
              </h3>
              <button onClick={() => setShowAdvancedFilters(false)} className="text-slate-400 hover:text-slate-600 transition-colors p-1 rounded-lg hover:bg-slate-50" data-id="element-1027" data-mp="yc2zuu8k0s3d">
                <XIcon className="w-5 h-5" data-id="element-1028" data-mp="188xuv35mcacw" />
              </button>
            </div>

            <div className="p-6 space-y-6" data-id="element-1029" data-mp="2sr8h54meugit">
              <div className="grid grid-cols-2 gap-4" data-id="element-1030" data-mp="2so47hrq6eskr">
                <div data-id="element-1031" data-mp="2nqkt8rthafst">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1032" data-mp="2ntgp8alrmuem">
                    Statut de carte
                  </label>
                  <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5]" data-id="element-1033" data-mp="2dtprm01wrzab">
                    <option data-id="element-1034" data-mp="3bisvp2ppkod8">Tous</option>
                    <option data-id="element-1035" data-mp="36hlmr0btxj4z">Actif</option>
                    <option data-id="element-1036" data-mp="36in9w364dw32">En création</option>
                    <option data-id="element-1037" data-mp="31qn3pszgi6y1">En traitement</option>
                    <option data-id="element-1038" data-mp="31pc3u494tjc7">Expiré</option>
                  </select>
                </div>
                <div data-id="element-1039" data-mp="2wriux3gg2b88">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1040" data-mp="2wq7tvbedvhkt">
                    Type de compte
                  </label>
                  <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5]" data-id="element-1041" data-mp="3pghem507tlfn">
                    <option data-id="element-1042" data-mp="2xrbshhpg7vx0">Tous</option>
                    <option data-id="element-1043" data-mp="32kwqvauyerwq">Administrateur global</option>
                    <option data-id="element-1044" data-mp="2osgjjxv0s7q0">Bibliothèque</option>
                    <option data-id="element-1045" data-mp="2otrmxwkjzdgl">Loisirs</option>
                  </select>
                </div>
                <div data-id="element-1046" data-mp="2tsmgntk26mfh">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1047" data-mp="2ts2ug0ndlbvn">
                    Courriel confirmé
                  </label>
                  <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5]" data-id="element-1048" data-mp="3lih3njkg200z">
                    <option data-id="element-1049" data-mp="37ipsrrp84zr7">Tous</option>
                    <option data-id="element-1050" data-mp="3chjaxxfghexp">Confirmé</option>
                    <option data-id="element-1051" data-mp="3cghneth96zz3">Non confirmé</option>
                  </select>
                </div>
              </div>

              <div className="pt-4 border-t border-slate-100" data-id="element-1052" data-mp="1w5vskyighxmz">
                <h4 className="text-sm font-bold text-[#0F172A] mb-3" data-id="element-1053" data-mp="213xedr79ob25">
                  Adresse
                </h4>
                <div className="flex gap-3" data-id="element-1054" data-mp="1ththfxkgabfg">
                  <div className="w-24" data-id="element-1055" data-mp="1okjtyngmg9u9">
                    <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1056" data-mp="1oji7lmu5o0x8">
                      Numéro
                    </label>
                    <input type="text" placeholder="123" className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5]" data-id="element-1057" data-mp="1xkyj5xwpi931" />
                  </div>
                  <div className="flex-1" data-id="element-1058" data-mp="15u22em7izkah">
                    <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1059" data-mp="15vd8isog144r">
                      Nom de rue
                    </label>
                    <input type="text" placeholder="Nom de rue" className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5]" data-id="element-1060" data-mp="1euqjxqw4o2s4" />
                  </div>
                  <div className="w-24" data-id="element-1061" data-mp="m6kwuxhlq1p4">
                    <label className="block text-xs font-medium text-slate-500 mb-1" data-id="element-1062" data-mp="m5jdm5qfm8wb">
                      Code postal
                    </label>
                    <input type="text" placeholder="A1A 1A1" className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5]" data-id="element-1063" data-mp="39sg3qyuvo3d7" />
                  </div>
                </div>
              </div>
            </div>

            <div className="px-6 py-4 border-t border-slate-100 flex justify-end bg-slate-50/50" data-id="element-1064" data-mp="1c4it03qd7d5">
              <button onClick={() => setShowAdvancedFilters(false)} className="bg-[#4F46E5] hover:bg-[#4338CA] text-white px-5 py-2 rounded-lg text-sm font-bold transition-colors shadow-sm" data-id="element-1065" data-mp="3tfxbmu89xy1q">
                Appliquer les filtres
              </button>
            </div>
          </div>
        </div>}
    </div>;
}